const PUBLIC_ASSET_BASE = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');

export const getPublicAssetUrl = (assetPath = '') => {
  if (!assetPath) {
    return assetPath;
  }

  if (/^(?:https?:)?\/\//.test(assetPath) || assetPath.startsWith('data:')) {
    return assetPath;
  }

  const normalizedPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;

  return PUBLIC_ASSET_BASE ? `${PUBLIC_ASSET_BASE}${normalizedPath}` : normalizedPath;
};

export default getPublicAssetUrl;
